import React from 'react';
import StrengthWeaknessTopic from '../../../components/strength-weakness-topic/strength-weakness-topic';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import {
    ACTIVITIES,
    ALL_CLASSES,
    TOPICS
} from '../../../components/report-filters/filter-constants';

const CLASS_NAME = 'classroomName';
const TITLE = 'title';

const STRENGTH_TAB = 0;
const WEAKNESS_TAB = 1;

const SCORE_BAND_COLOURS = {
    MASTERED: '#37c97c',
    CONSOLIDATING: '#81daab',
    DEVELOPING: '#f69e13',
    EMERGING: '#e06d3f',
    POOR: '#c53902',
    DEFAULT: '#ffffff'
};

const ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG = {
    cols: [
        {
            id: CLASS_NAME,
            name: getTranslationKey(ALL_CLASSES),
            doTranslation: true,
            truncate: true
        },
        {
            id: TITLE,
            name: 'Relative strengths',
            doTranslation: true,
            transform: (row) => (
                <StrengthWeaknessTopic
                    topicName={row.title}
                    result={row.averageResult}
                />
            )
        }
    ],
    colGroups: []
};

const TOPICS_TABLE_CONFIG = {
    cols: [
        {
            id: TITLE,
            name: getTranslationKey(TOPICS),
            doTranslation: true,
            transform: (row) => (
                <StrengthWeaknessTopic
                    topicName={row.title}
                    result={row.averageResult}
                />
            )
        }
    ],
    colGroups: []
};

const ACTIVITIES_TABLE_CONFIG = {
    cols: [
        {
            id: TITLE,
            name: getTranslationKey(ACTIVITIES),
            doTranslation: true,
            transform: (row) => (
                <StrengthWeaknessTopic
                    topicName={row.title}
                    result={row.averageResult}
                />
            )
        }
    ],
    colGroups: []
};

export {
    ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG,
    TOPICS_TABLE_CONFIG,
    ACTIVITIES_TABLE_CONFIG,
    TITLE,
    STRENGTH_TAB,
    WEAKNESS_TAB,
    SCORE_BAND_COLOURS
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/common/strength-and-weaknesses-constants.js